import React from 'react';
import { ExternalLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import css from '../TermsOfServicePage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function ProfessionalTosGerman() {
  const history = useHistory();
  return (
    <div className="terms-page">
      <h1>Nutzungsbedingungen für Professionals &amp; Experten</h1>

      <h2>DOKUMENTINFORMATIONEN</h2>
      <p>
        Gilt für: Spezialisten und Experten, die in diesem Dokument insgesamt als „professionelle
        Nutzer“ (Anbieter) beschrieben werden und Dienstleistungen über die VivianLab-Plattform
        anbieten.
        <br />
        Zuletzt geändert: 5.12.2025
        <br />
        Zugehörige Dokumente:{' '}
        <span
          className={css.termsLink}
          role="button"
          onClick={() => history.push('/de/terms-of-service?tab=consumer')}
        >
          Nutzungsbedingungen für Verbraucher
        </span>{' '}
        | <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> |{' '}
        <ExternalLink href="/de/data-processing-addendum">
          Datenverarbeitungsvereinbarung (Anhang 1)
        </ExternalLink>
      </p>

      <h2>Präambel</h2>
      <p>
        Diese Nutzungsbedingungen gelten ausschließlich für Fachleute und Experten (im Folgenden auch
        als „Anbieter“ bezeichnet), die sich registrieren und Dienstleistungen über die Websites
        www.vivianlab.gr, www.vivianlab.com und www.vivianlab.health sowie über die dazugehörigen
        mobilen Anwendungen (zusammenfassend als „Plattform“ bezeichnet) anbieten.
      </p>
      <p>
        Die Plattform ist Eigentum des Unternehmens mit dem Namen „VIVIANLAB LTD“ und dem Markennamen
        „Vivian Lab“ mit Sitz in 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1, VAT BG207933919,
        E-Mail-Adresse info@vivianlab.com (das „Unternehmen“).
      </p>
      <p>
        Alle Inhalte, Marken und Domainnamen (einschließlich www.vivianlab.gr, www.vivianlab.com und
        www.vivianlab.health) sind das ausschließliche Eigentum des Unternehmens und durch Urheberrecht,
        Markenrecht und andere geltende Rechte des geistigen Eigentums geschützt.
      </p>
      <p>
        Das Unternehmen verpflichtet sich, sicherzustellen, dass die Plattform für alle Nutzer,
        einschließlich Menschen mit Behinderungen, gemäß dem Europäischen Gesetz zur Barrierefreiheit
        (Richtlinie (EU) 2019/882) und den einschlägigen technischen Standards zugänglich ist.
      </p>

      <h2>1. DEFINITIONEN</h2>
      <p>Im Sinne dieser Nutzungsbedingungen:</p>
      <ul>
        <li>
          <strong>„Professioneller Nutzer“ oder „Anbieter“:</strong> Jede natürliche oder juristische
          Person, die auf der Plattform registriert ist, um professionelle Dienstleistungen anzubieten
          (einschließlich Gesundheitsfachkräfte, Berater und Unternehmen, die im Gesundheits- und
          Wellnessbereich tätig sind).
        </li>
        <li>
          <strong>„Verbraucher“ oder „Nutzer“:</strong> Jede natürliche Person, die die Plattform
          nutzt, um Dienstleistungen oder digitale Inhalte von professionellen Nutzern zu suchen, zu
          buchen oder zu erhalten.
        </li>
        <li>
          <strong>„Plattform“ oder „Marktplatz“:</strong> Die vom Unternehmen unter dem Markennamen
          VivianLab betriebene Online-Umgebung, die über die Website und mobile Anwendungen zugänglich
          ist.
        </li>
        <li>
          <strong>„Unternehmen“:</strong> „VIVIANLAB LTD“ mit Sitz in 1612 SOFIA BUL. TSAR BORIS III
          № 81 ET.1, AP.1, VAT BG207933919, E-Mail-Kontakt info@vivianlab.com, die juristische
          Person, die Eigentümerin und Betreiberin der Plattform ist.
        </li>
        <li>
          <strong>„Dienstleistungen“:</strong> Alle Vermittlungsdienstleistungen, die vom Unternehmen
          über die Plattform erbracht werden, einschließlich Profilanzeige, Terminbuchung, Video-Beratungen,
          Bildungsinhalte und KI-gestützte Tools.
        </li>
        <li>
          <strong>„Vereinbarung“:</strong> Diese Nutzungsbedingungen zusammen mit der{' '}
          <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> und der{' '}
          <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung</ExternalLink>.
        </li>
        <li>
          <strong>„Werktage“:</strong> Alle Tage außer Samstagen, Sonntagen und gesetzlichen Feiertagen in
          Griechenland.
        </li>
        <li>
          <strong>„Sitzung“ oder „Termin“:</strong> Eine über die Plattform vereinbarte Beratung oder
          Leistungserbringung zwischen einem professionellen Nutzer und einem Verbraucher.
        </li>
        <li>
          <strong>„Fachliche Inhalte“:</strong> Alle Informationen, Ratschläge, Empfehlungen,
          Schulungsmaterialien oder sonstigen Inhalte (einschließlich solcher, die im Rahmen von
          Webinaren, Sitzungen, Artikeln, Beiträgen und Videos bereitgestellt werden), die vom
          professionellen Nutzer über die Plattform oder in Zusammenarbeit mit dem Unternehmen
          bereitgestellt werden.
        </li>
        <li>
          <strong>„Gemeinsam erstellte Inhalte“:</strong> Alle Inhalte (einschließlich, aber nicht
          beschränkt auf Videos, Webinare, Online-Kurse, Artikel, Social-Media-Inhalte, Interviews und
          Aufzeichnungen), die gemeinsam vom professionellen Nutzer und dem Unternehmen erstellt oder vom
          Unternehmen unter Einbeziehung des professionellen Nutzers produziert werden.
        </li>
      </ul>

      <h2>2. ANNAHME DER BEDINGUNGEN</h2>
      <p>
        Mit der Registrierung auf der Plattform oder deren Nutzung erklären Sie (der professionelle
        Nutzer) sich vollständig und vorbehaltlos damit einverstanden und verpflichten sich, an folgende
        Bestimmungen gebunden zu sein:
      </p>
      <ol>
        <li>diese Nutzungsbedingungen für professionelle Nutzer;</li>
        <li>
          die <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink>;
        </li>
        <li>
          die{' '}
          <ExternalLink href="/de/data-processing-addendum">
            Datenverarbeitungsvereinbarung (Anhang 1)
          </ExternalLink>
          ; und
        </li>
        <li>
          die <ExternalLink href="/de/cookie-policy">Cookie-Richtlinie</ExternalLink>.
        </li>
      </ol>
      <p>Wenn Sie diesen Bedingungen nicht zustimmen, dürfen Sie sich nicht registrieren oder die Plattform nutzen.</p>

      <h2>3. DATENSCHUTZ UND DSGVO-ROLLEN</h2>
      <h3>3.1 Das Unternehmen als Verantwortlicher</h3>
      <p>
        Das Unternehmen fungiert als Verantwortlicher für personenbezogene Daten, die Sie dem
        Unternehmen direkt zu folgenden Zwecken zur Verfügung stellen:
      </p>
      <ul>
        <li>Einrichtung und Verwaltung Ihres Professional-Benutzerkontos</li>
        <li>Abwicklung von Abonnementzahlungen</li>
        <li>Versendung von Newslettern und Marketingmitteilungen (mit Ihrer Einwilligung)</li>
        <li>Plattformverwaltung und -sicherheit</li>
      </ul>
      <p>
        Alle Informationen zu den Verarbeitungszwecken, den Rechtsgrundlagen für die Verarbeitung, den
        Aufbewahrungsfristen, den Datenempfängern und Ihren Rechten als betroffene Person sind in unserer{' '}
        <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> ausführlich dargelegt.
      </p>
      <h3>3.2 Das Unternehmen als Auftragsverarbeiter</h3>
      <p>
        Wenn Sie über die Plattform Dienstleistungen für Verbraucher erbringen, fungieren Sie (der
        professionelle Nutzer) als Verantwortlicher für personenbezogene Daten im Zusammenhang mit
        diesen Dienstleistungen (einschließlich Terminangaben, Beratungsnotizen und etwaiger
        Gesundheitsdaten).
      </p>
      <p>
        In diesem Fall fungiert das Unternehmen als Auftragsverarbeiter, der diese Daten ausschließlich in
        Ihrem Auftrag und auf Ihre ausdrücklichen Anweisungen hin erhebt und verarbeitet.
      </p>
      <p>
        Das Rechtsverhältnis, die Sicherheitsmaßnahmen und die Verpflichtungen zur Datenverarbeitung
        unterliegen der{' '}
        <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung (DPA)</ExternalLink>
        , die als Anhang 1 beigefügt ist und integraler Bestandteil dieser Nutzungsbedingungen ist.
      </p>
      <p>
        Mit der Annahme dieser Nutzungsbedingungen akzeptieren Sie gleichzeitig die{' '}
        <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung (Anhang 1)</ExternalLink>.
      </p>

      <h3>
        <FormattedMessage id="ProfileImagesSection.titleWithNumber" values={{ number: '3.3' }} />
      </h3>
      <ul>
        <li>
          <FormattedMessage id="ProfileImagesSection.cameraAccess" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.usage" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.storage" />
        </li>
      </ul>

      <h2>4. ONLINE-DIENSTLEISTUNGEN DER PLATTFORM</h2>
      <p>
        Die Plattform ist ein Vermittlungsmarktplatz, der sich auf Gesundheit, Wellness und damit
        verbundene Beratungsdienstleistungen spezialisiert hat. Die Plattform erbringt selbst keine
        medizinischen, gesundheitlichen oder professionellen Dienstleistungen; sie stellt lediglich die
        technischen Mittel bereit, damit professionelle Nutzer mit Verbrauchern in Kontakt treten und
        ihnen Dienstleistungen anbieten können.
      </p>
      <p>Zu den über die Plattform verfügbaren Dienstleistungen gehören:</p>
      <ul>
        <li>
          Anzeige des beruflichen Profils (Kontaktdaten, Qualifikationen, Spezialisierungen, angebotene
          Dienstleistungen, Preise, Arbeitszeiten)
        </li>
        <li>Online-Terminbuchung</li>
        <li>Video-Beratungen (über Meet, Calendly oder das plattformeigene System)</li>
        <li>Gruppen-Webinare und Hotlines</li>
        <li>Chat- und Messaging-Dienste</li>
        <li>Bildungsinhalte (Artikel, Videos, Rezepte)</li>
        <li>KI-gestützte Tools (Symptomverfolgung, personalisierte Beratung)</li>
      </ul>
      <p>
        Das Unternehmen verpflichtet sich, sicherzustellen, dass die Plattform und die Mittel zur
        Erbringung von Online-Dienstleistungen vertragsgemäß sind und für die Zwecke geeignet sind, für die
        digitale Vermittlungsdienste normalerweise genutzt werden, und zwar mit der erwarteten
        professionellen Sorgfalt und Fachkompetenz.
      </p>

      <h2>5. PFLICHTEN PROFESSIONELLER NUTZER</h2>
      <h3>5.1 Registrierung und Profilanforderungen</h3>
      <p>Professionelle Nutzer müssen:</p>
      <ul>
        <li>
          Genaue, vollständige und aktuelle Informationen bereitstellen, darunter:
          <ul>
            <li>Vollständiger Name (oder Name der juristischen Person)</li>
            <li>Geschäftsadresse und Firmensitz</li>
            <li>Kontaktdaten (Telefon, E-Mail, Website)</li>
            <li>Zulassungsnummer (ausgestellt von der zuständigen Berufsvereinigung oder Aufsichtsbehörde)</li>
            <li>Berufliche Qualifikationen, Zertifizierungen und Fachgebiete</li>
          </ul>
        </li>
        <li>
          ihr Profil unverzüglich zu aktualisieren, wenn sich Informationen ändern, einschließlich der
          Verlängerung oder des Ablaufs von Lizenzen
        </li>
      </ul>
      <p>
        Der professionelle Nutzer ist allein dafür verantwortlich, wahrheitsgemäße und genaue Informationen
        anzugeben, und garantiert sowohl deren Rechtmäßigkeit als auch den rechtmäßigen Besitz und die
        rechtmäßige Nutzung. Der professionelle Nutzer haftet für alle Schäden, die dem Unternehmen aufgrund
        eines Verstoßes gegen diese Verpflichtung entstehen.
      </p>
      <h3>5.2 Einhaltung von Gesetzen und Berufsstandards</h3>
      <p>Professionelle Nutzer müssen:</p>
      <ul>
        <li>
          alle geltenden nationalen, europäischen und internationalen Gesetze einhalten, einschließlich, aber
          nicht beschränkt auf:
          <ul>
            <li>Verbraucherschutzgesetze (Gesetz 2251/1994, PD 131/2003)</li>
            <li>Vorschriften zum E-Commerce und zur elektronischen Kommunikation</li>
            <li>Datenschutzgesetze (DSGVO)</li>
            <li>Berufliche Ethik- und Verhaltenskodizes</li>
          </ul>
        </li>
        <li>keine irreführende Werbung betreiben oder unlauteren Wettbewerb betreiben</li>
        <li>sicherstellen, dass die Preisgestaltung den Anforderungen an die wirtschaftliche Transparenz entspricht</li>
        <li>über den erforderlichen Versicherungsschutz für die erbrachten Dienstleistungen verfügen</li>
        <li>
          den Verbrauchern und dem Unternehmen ordnungsgemäße Steuerunterlagen (Quittungen, Rechnungen) ausstellen,
          wie es das Gesetz vorschreibt
        </li>
      </ul>
      <p>
        Das Unternehmen legt die Preise für Dienstleistungen nicht fest, kontrolliert sie nicht und überprüft sie
        nicht. Professionelle Nutzer sind allein dafür verantwortlich, Gebühren festzulegen und die Einhaltung
        aller geltenden Preis- und Transparenzgesetze sicherzustellen.
      </p>
      <h3>5.3 Dienstleistungserbringung und professionelles Verhalten</h3>
      <p>Professionelle Nutzer müssen:</p>
      <ul>
        <li>unverzüglich auf Mitteilungen des Unternehmens und der Verbraucher reagieren</li>
        <li>Dienstleistungen professionell und sorgfältig erbringen</li>
        <li>die Vertraulichkeit aller von Verbrauchern erhaltenen Informationen wahren</li>
        <li>Verbraucherdaten nicht für andere Zwecke als die Erbringung der vertraglich vereinbarten Dienstleistung missbrauchen</li>
        <li>in gutem Glauben und unter Einhaltung der Geschäftsethik handeln</li>
      </ul>
      <p>Professionelle Beratung und Informationen</p>
      <p>Professionelle Nutzer erkennen an und erklären sich damit einverstanden, dass:</p>
      <ul>
        <li>
          Sie allein für alle Ratschläge, Informationen und Inhalte verantwortlich sind, die sie Verbrauchern und
          der Öffentlichkeit über die Plattform oder im Rahmen einer Zusammenarbeit mit dem Unternehmen zur
          Verfügung stellen.
        </li>
        <li>
          Sie sicherstellen müssen, dass alle Ratschläge und Informationen korrekt, aktuell und mit den geltenden
          Gesetzen, beruflichen Standards und ethischen Kodizes vereinbar sind.
        </li>
        <li>
          Sie dürfen keine medizinischen Ratschläge oder Diagnosen erteilen, wenn sie nicht gemäß geltendem Recht
          ordnungsgemäß zugelassen und dazu befugt sind.
        </li>
        <li>
          Sie tragen die volle und ausschließliche Verantwortung für alle Folgen, die sich aus ihren Ratschlägen,
          Empfehlungen oder Unterlassungen ergeben.
        </li>
      </ul>
      <p>
        Wenn ein professioneller Nutzer die vereinbarte Dienstleistung nicht innerhalb des festgelegten Zeitraums
        erbringt, ohne dies zuvor schriftlich angekündigt zu haben und ohne triftigen Grund, kann das Unternehmen
        nach eigenem Ermessen den Zugang des professionellen Nutzers aussetzen oder beenden, Zahlungen zurückhalten
        oder zurückerstatten oder andere erforderliche Maßnahmen ergreifen. Wiederholte oder ungerechtfertigte
        Versäumnisse können zu einem dauerhaften Ausschluss von der Plattform und/oder rechtlichen Schritten führen.
      </p>
      <h3>5.4 Verbot nicht autorisierter Termine und Stornierungen</h3>
      <p>
        Sollte ein professioneller Nutzer vier (4) oder mehr über die Plattform vereinbarte Termine ohne triftigen
        Grund absagen, behält sich das Unternehmen das Recht vor, die Zusammenarbeit zu beenden und das Profil des
        professionellen Nutzers von der Plattform zu entfernen.
      </p>
      <h3>5.5 Kontosicherheit</h3>
      <p>
        Professionelle Nutzer sind für die Wahrung der Vertraulichkeit und Sicherheit ihrer Zugangsdaten,
        einschließlich Passwörtern und Authentifizierungsdaten, verantwortlich. Professionelle Nutzer müssen
        sichere, einmalige Passwörter wählen und angemessene Maßnahmen ergreifen, um ihre Konten vor unbefugtem
        Zugriff zu schützen. Das Unternehmen haftet nicht für Verluste oder Schäden, die dadurch entstehen, dass
        ein professioneller Nutzer diesen Verpflichtungen zur Kontosicherheit nicht nachkommt.
      </p>

      <h2>6. PREISE, ZAHLUNGEN UND FINANZIELLE BEDINGUNGEN</h2>
      <h3>6.1 Preisgestaltung der Dienstleistungen</h3>
      <ul>
        <li>Professionelle Nutzer legen ihre Dienstleistungspreise selbst fest.</li>
        <li>Das Unternehmen greift nicht in Preisentscheidungen ein.</li>
        <li>
          Professionelle Nutzer sind allein verantwortlich für:
          <ul>
            <li>die Gewährleistung, dass die Preisgestaltung allen geltenden wirtschafts- und transparenzrechtlichen Vorschriften entspricht</li>
            <li>die Ausstellung ordnungsgemäßer Steuerunterlagen (Rechnungen, Quittungen) an Verbraucher</li>
          </ul>
        </li>
      </ul>
      <p>
        Professionelle Nutzer können Gruppensitzungen oder Hotlines kostenlos oder gegen eine vom Unternehmen
        abgewickelte Zahlung anbieten. Professionelle Nutzer, die kostenlose Gruppensitzungen oder Hotlines
        anbieten, erkennen an und erklären sich damit einverstanden, dass sie allein für den Inhalt und die
        Durchführung solcher Sitzungen verantwortlich sind und unter keinen Umständen eine Erstattung, Zahlung
        oder Entschädigung vom Unternehmen erwarten oder geltend machen, auch nicht in Fällen, in denen keine
        Verbraucher teilnehmen.
      </p>
      <h3>6.2 Zahlungsabwicklung</h3>
      <p>
        Zahlungen werden über Stripe, einen externen Zahlungsdienstleister, abgewickelt. Mit der Registrierung
        ihrer Zahlungsdaten akzeptieren professionelle Nutzer die Allgemeinen Geschäftsbedingungen von Stripe.
      </p>
      <p>
        Das Unternehmen wickelt Zahlungen nicht direkt ab und ist nicht für Probleme bei der Zahlungsabwicklung
        verantwortlich.
      </p>
      <p>Zahlungsablauf:</p>
      <ol>
        <li>Wenn ein Verbraucher einen Termin bucht, wird seine Kreditkarte vorab autorisiert (es erfolgt keine Belastung).</li>
        <li>
          Innerhalb von 7 Tagen nach der Sitzung muss der professionelle Nutzer den Abschluss per E-Mail oder über
          die Zahlungsplattform bestätigen.
        </li>
        <li>
          Nach der Bestätigung wird die Karte des Verbrauchers belastet und der Betrag innerhalb von 5 Werktagen auf
          das Bankkonto des professionellen Nutzers überwiesen.
        </li>
      </ol>
      <p>
        Wenn der professionelle Nutzer die Zahlung nicht innerhalb von 7 Tagen bestätigt, behält sich das
        Unternehmen das Recht vor, die Zahlung an den Verbraucher zurückzuerstatten. Liefert der professionelle
        Nutzer jedoch den Nachweis, dass die Sitzung abgeschlossen wurde, kann das Unternehmen nach eigenem
        Ermessen die Zahlung an den professionellen Nutzer entsprechend vornehmen.
      </p>
      <h3>6.3 Erstattungen und Einbehaltung von Zahlungen</h3>
      <p>
        Das Unternehmen kann dem Verbraucher eine Rückerstattung gewähren, wenn es auf der Grundlage von Belegen und
        nach vorheriger Benachrichtigung des professionellen Nutzers sowie Gewährung einer Gelegenheit zur
        Stellungnahme feststellt, dass die Dienstleistung nicht wie vorgesehen erbracht oder abgeschlossen wurde. In
        solchen Fällen kann das Unternehmen, selbst wenn der professionelle Nutzer bereits Gelder erhalten hat, die
        Rückgabe dieser Gelder zum Zwecke der Rückerstattung an den Verbraucher verlangen, sofern das Verfahren im
        Einklang mit geltendem Recht sowie unter Vorlage einer angemessenen Begründung und Dokumentation durchgeführt
        wird.
      </p>
      <p>
        Das Unternehmen hat dem betroffenen Verbraucher auf Anfrage eine kurze Begründung für die
        Rückerstattungsentscheidung zu übermitteln, sofern dies nicht gesetzlich untersagt oder zur
        Betrugsbekämpfung erforderlich ist.
      </p>
      <h3>6.4 Gutscheine und Aktionszahlungen</h3>
      <p>
        Wenn ein Verbraucher einen vom Unternehmen bereitgestellten Gutschein oder Aktionscode einlöst, wird der
        professionelle Nutzer direkt vom Unternehmen (und nicht vom Verbraucher) bezahlt. In solchen Fällen gilt
        Folgendes:
      </p>
      <ul>
        <li>
          Der professionelle Nutzer muss dem Unternehmen innerhalb von 7 Tagen nach der Sitzung eine Rechnung oder
          einen Leistungsnachweis (keine Quittung) ausstellen.
        </li>
        <li>Wird das Dokument nicht innerhalb dieser Frist ausgestellt, behält sich das Unternehmen das Recht vor, die Zahlung zu verweigern.</li>
      </ul>
      <h3>6.5 Technische Ausfälle</h3>
      <p>
        Sollte ein technisches Problem einen professionellen Nutzer oder Verbraucher daran hindern, an einer
        geplanten Sitzung teilzunehmen (z. B. eine Störung der Plattform oder eine Verbindungsunterbrechung), kann
        das Unternehmen die Sitzung nach eigenem Ermessen absagen. In solchen Fällen:
      </p>
      <ul>
        <li>Es fallen keine Kosten an</li>
        <li>Der professionelle Nutzer hat keinen Anspruch auf eine Vergütung</li>
        <li>Die Sitzung kann kostenlos verschoben werden</li>
      </ul>
      <p>Dies liegt im alleinigen Ermessen des Unternehmens.</p>
      <h3>6.6 Automatischer Leistungsnachweis</h3>
      <p>
        Das automatisierte System des Unternehmens erstellt Leistungsnachweise für den internen Gebrauch. Dieser
        automatisierte Nachweis ersetzt nicht das Steuerdokument (Rechnung oder Quittung), das der gewerbliche
        Nutzer gemäß den geltenden Steuer- und Rechnungslegungsvorschriften ausstellen muss.
      </p>

      <h2>7. WIDERRUFSRECHT DER VERBRAUCHER</h2>
      <p>
        Verbraucher haben das Recht, innerhalb von 14 Kalendertagen ab dem Datum der Buchung von einem vereinbarten
        Termin zurückzutreten, es sei denn:
      </p>
      <ul>
        <li>Die Dienstleistung wurde bereits erbracht; oder</li>
        <li>
          Der Verbraucher stimmt der Aufnahme der Dienstleistung während der Widerrufsfrist ausdrücklich zu und
          erkennt den Verlust des Widerrufsrechts an.
        </li>
      </ul>
      <p>
        Für herunterladbare digitale Inhalte (z. B. Artikel, E-Books, Videos): Durch das Herunterladen verzichtet
        der Verbraucher ausdrücklich auf sein Widerrufsrecht.
      </p>
      <p>Stornierungsbedingungen für Termine:</p>
      <ul>
        <li>Mehr als 24 Stunden vor dem Termin: Volle Rückerstattung</li>
        <li>Weniger als 60 Minuten vor dem Termin: Es fallen Stornierungsgebühren an; keine Rückerstattung</li>
      </ul>
      <p>
        Aufgrund von Bearbeitungsanforderungen kann es bis zu 14 Werktage dauern, bis die Rückerstattung auf dem
        Konto des Verbrauchers gutgeschrieben wird.
      </p>

      <h2>8. PROFESSIONELLE UNABHÄNGIGKEIT</h2>
      <h3>8.1 Unabhängige Auftragnehmer</h3>
      <p>
        Professionelle Nutzer sind unabhängige Auftragnehmer und keine Mitarbeiter, Vertreter oder Partner des
        Unternehmens.
      </p>
      <h3>8.2 Keine Exklusivität</h3>
      <p>
        Diese Vereinbarung begründet keine exklusive Geschäftsbeziehung. Professionelle Nutzer dürfen
        Dienstleistungen für Dritte erbringen und anderen geschäftlichen Tätigkeiten nachgehen.
      </p>
      <h3>8.3 Professionelle Verantwortung</h3>
      <p>Professionelle Nutzer sind allein verantwortlich für:</p>
      <ul>
        <li>den Inhalt, die Qualität und die Erbringung ihrer Dienstleistungen</li>
        <li>ihre eigenen steuerlichen Verpflichtungen, Sozialversicherungsbeiträge und Berufshaftpflichtversicherungen</li>
        <li>die Einholung und Aufrechterhaltung aller erforderlichen Lizenzen, Genehmigungen und Zertifizierungen</li>
      </ul>
      <p>
        Professionelle Nutzer sind nicht befugt, Verträge abzuschließen, Verpflichtungen einzugehen oder im Namen des
        Unternehmens zu handeln.
      </p>
      <p>Zusammenarbeit bei Inhalten</p>
      <p>
        Von Zeit zu Zeit kann das Unternehmen professionelle Nutzer einladen, an Inhaltsinitiativen teilzunehmen,
        wie z. B. Webinaren, Meisterkursen, Gruppensitzungen, Live-Streams (einschließlich auf Instagram und anderen
        Social-Media-Plattformen), Interviews, Podcasts oder der Erstellung von Schulungsmaterialien. Die Teilnahme
        an solchen Initiativen ist freiwillig, doch sobald ein professioneller Nutzer der Teilnahme zustimmt,
        unterliegen alle daraus resultierenden gemeinsam erstellten Inhalte Abschnitt 10.3 (Gemeinsam erstellte
        Inhalte und in Auftrag gegebene Materialien). Der professionelle Nutzer darf keine Entfernung, Rücknahme oder
        Einschränkung der gemeinsam erstellten Inhalte verlangen, es sei denn, dies ist nach zwingendem Recht
        erforderlich.
      </p>

      <h2>9. VERBOTENES VERHALTEN</h2>
      <p>Professionelle Nutzer dürfen nicht:</p>
      <ul>
        <li>Fake-Konten erstellen oder betrügerische Handlungen begehen</li>
        <li>Personenbezogene Daten von Verbrauchern sammeln, speichern oder missbrauchen</li>
        <li>Irreführende Werbung betreiben oder unlauteren Wettbewerb betreiben</li>
        <li>Beleidigende, bedrohliche oder diskriminierende Sprache verwenden</li>
        <li>
          Verbraucher oder andere Nutzer belästigen (Belästigung umfasst verbale oder schriftliche Äußerungen, die
          darauf abzielen, psychischen oder physischen Schaden zuzufügen)
        </li>
        <li>Malware, Viren oder schädliche Software hochladen</li>
        <li>Inhalte der Plattform ohne schriftliche Genehmigung kopieren, verbreiten oder vervielfältigen</li>
        <li>Die Marken, das Branding oder die Identität des Unternehmens ohne Zustimmung verwenden</li>
      </ul>
      <p>
        Die wichtigsten Werte, die die Plattform leiten, sind Wertschätzung und Respekt. Diskriminierung aufgrund von
        Geschlecht, Geschlechtsidentität, Nationalität, Religion, Behinderung, sexueller Orientierung oder Alter ist
        strengstens untersagt.
      </p>
      <p>Werden diese Regeln nicht befolgt, kann das Unternehmen:</p>
      <ul>
        <li>Das Konto des professionellen Nutzers unverzüglich deaktivieren</li>
        <li>Den Vertrag kündigen</li>
        <li>Strafverfolgungsbehörden kontaktieren</li>
        <li>Schadensersatz und andere Rechtsmittel einfordern</li>
      </ul>

      <h2>10. RECHTE AN GEISTIGEM EIGENTUM</h2>
      <h3>10.1 Rechte des Unternehmens</h3>
      <p>
        Alle Inhalte, das Design, Marken, Logos und die Software auf der Plattform sind das
        ausschließliche Eigentum des Unternehmens und durch Urheber-, Marken- und andere Rechte an
        geistigem Eigentum geschützt.
      </p>
      <p>Professionelle Nutzer dürfen nicht:</p>
      <ul>
        <li>Inhalte der Plattform ohne vorherige schriftliche Zustimmung kopieren, vervielfältigen, verbreiten oder anzeigen</li>
        <li>Die Marke oder das Branding des Unternehmens zur Kennzeichnung oder Werbung für Produkte oder Dienstleistungen Dritter verwenden</li>
        <li>Die Software oder Systeme der Plattform zurückentwickeln, disassemblieren oder stören</li>
      </ul>
      <p>
        Markenschutz: „VivianLab“ ist eine eingetragene Marke, die gemäß Artikel 6a der Pariser
        Verbandsübereinkunft und der Richtlinie (EU) 2015/2436 des Europäischen Parlaments und des Rates vom
        16. Dezember 2015 zur Angleichung der Rechtsvorschriften der Mitgliedstaaten über die Marken geschützt
        ist.
      </p>
      <h3>10.2 Profilinhalte professioneller Nutzer</h3>
      <p>
        Durch das Hochladen von Inhalten in Ihr Profil (einschließlich Fotos, Beschreibungen, Artikeln und
        Videos):
      </p>
      <ul>
        <li>behalten Sie das Eigentum an Ihren Inhalten</li>
        <li>
          gewähren Sie dem Unternehmen eine nicht-exklusive, weltweite und gebührenfreie Lizenz zur Nutzung,
          Darstellung und Verbreitung Ihrer Inhalte auf der Plattform zum Zwecke der Bereitstellung der Dienste
        </li>
        <li>
          versichern Sie, dass Sie über alle erforderlichen Rechte an diesen Inhalten verfügen und dass diese keine
          Rechte Dritter verletzen.
        </li>
      </ul>
      <h3>10.3 Gemeinsam erstellte Inhalte und beauftragte Materialien</h3>
      <ol>
        <li>
          <strong>Übertragung von Rechten des geistigen Eigentums</strong>
          <br />
          Soweit gesetzlich zulässig, tritt der professionelle Nutzer hiermit unwiderruflich alle weltweiten Rechte
          des geistigen Eigentums, einschließlich, aber nicht beschränkt auf Urheberrechte und verwandte
          Schutzrechte, an allen gemeinsam mit dem Unternehmen erstellten Inhalten und zwar für die gesamte
          Schutzdauer dieser Rechte und für alle Länder weltweit.
        </li>
        <li>
          <strong>Lizenz, wenn eine Übertragung nicht möglich ist</strong>
          <br />
          Ist eine Übertragung rechtlich nicht möglich, gewährt der professionelle Nutzer dem Unternehmen eine
          exklusive, weltweite, unbefristete, unwiderrufliche, übertragbare und unterlizenzierbare Lizenz zur
          Nutzung, Vervielfältigung, Änderung, Anpassung, Übersetzung, Verbreitung, Veröffentlichung, öffentlichen
          Aufführung, öffentlichen Vorführung, öffentlichen Wiedergabe und sonstigen Verwertung der gemeinsam
          erstellten Inhalte in jedem Format und über alle Medien.
        </li>
        <li>
          <strong>Recht auf Bearbeitung, Übersetzung und Anpassung</strong>
          <br />
          Das Unternehmen hat das Recht, die gemeinsam erstellten Inhalte zu bearbeiten, zu kürzen, anzupassen, mit
          anderen Inhalten zu kombinieren, daraus abgeleitete Werke zu erstellen und sie in jede beliebige Sprache zu
          übersetzen sowie sie für kommerzielle, pädagogische oder Marketingzwecke zu nutzen.
        </li>
        <li>
          <strong>Nutzung von Name, Bild und Ähnlichkeit</strong>
          <br />
          Der professionelle Nutzer gewährt dem Unternehmen das Recht, seinen Namen, seinen Berufstitel, sein Bild,
          seine Stimme und seine Ähnlichkeit, wie sie in den gemeinsam erstellten Inhalten enthalten sind, ausschließlich
          zum Zwecke der Werbung und Verwertung dieser Inhalte gemäß dieser Klausel zu nutzen.
        </li>
        <li>
          <strong>Keine zusätzliche Vergütung</strong>
          <br />
          Sofern nicht ausdrücklich schriftlich anders vereinbart, erkennt der professionelle Nutzer an, dass jede
          vereinbarte Vergütung oder kommerzielle Vereinbarung für die Erstellung gemeinsam erstellter Inhalte seine
          Vergütung vollständig abdeckt und er keinen Anspruch auf weitere Zahlungen, Lizenzgebühren oder eine Beteiligung
          an den Einnahmen hat.
        </li>
        <li>
          <strong>Urheberpersönlichkeitsrechte</strong>
          <br />
          Soweit dies nach geltendem Recht zulässig ist, verzichtet der professionelle Nutzer auf jegliche
          Urheberpersönlichkeitsrechte (oder erklärt sich bereit, diese nicht geltend zu machen) in Bezug auf die
          gemeinsam erstellten Inhalte gegenüber dem Unternehmen und dessen Lizenznehmern, Rechtsnachfolgern und
          Abtretungsempfängern.
        </li>
      </ol>

      <h2>11. HAFTUNGSBESCHRÄNKUNG</h2>
      <h3>11.1 Haftungsbeschränkung des Unternehmens</h3>
      <p>
        Die Plattform dient ausschließlich zu Informations- und Vermittlungszwecken. Sie bietet keine medizinische,
        gesundheitliche oder fachliche Beratung oder Dienstleistungen an.
      </p>
      <p>Soweit gesetzlich zulässig:</p>
      <p>Das Unternehmen haftet nicht für:</p>
      <ul>
        <li>den Inhalt, die Qualität oder das Ergebnis der von professionellen Nutzern erbrachten Dienstleistungen</li>
        <li>Stornierungen, Nichterscheinen oder nicht wahrgenommene Termine</li>
        <li>
          Schäden, Verluste oder Verletzungen, die sich aus den Dienstleistungen professioneller Nutzer oder aus
          Interaktionen mit Verbrauchern ergeben
        </li>
        <li>Einnahmeausfälle, entgangene Gewinne, Vertragsverluste oder besondere, indirekte oder Folgeschäden</li>
      </ul>
      <p>
        Die Plattform wird „wie besehen“ ohne jegliche Gewährleistung bereitgestellt, einschließlich, aber nicht
        beschränkt auf Gewährleistungen der Marktgängigkeit, der Eignung für einen bestimmten Zweck oder des
        unterbrechungsfreien Betriebs.
      </p>
      <p>
        Diese Haftungsbeschränkung schließt jedoch die Haftung des Unternehmens nicht aus und beschränkt sie nicht für:
        Tod oder Körperverletzung, die auf eigene Fahrlässigkeit oder vorsätzliches Fehlverhalten des Unternehmens
        zurückzuführen sind; jegliche zwingende gesetzliche Haftung, die gesetzlich nicht ausgeschlossen werden kann.
      </p>
      <p>
        Zur Vermeidung von Zweifeln: Das Unternehmen ist nicht verantwortlich für und übernimmt keine Haftung für
        Ratschläge, Empfehlungen, Aussagen oder Unterlassungen von professionellen Nutzern während Einzelsitzungen,
        Gruppen-Webinaren, Hotlines, Auftritten in sozialen Medien oder in professionellen Inhalten oder gemeinsam
        erstellten Inhalten.
      </p>
      <h3>11.2 Freistellung durch professionelle Nutzer</h3>
      <p>
        Professionelle Nutzer verpflichten sich, das Unternehmen von jeglichen Ansprüchen freizustellen, zu verteidigen
        und schadlos zu halten, die sich ergeben aus oder im Zusammenhang stehen mit der Erbringung von
        Dienstleistungen, Verstößen gegen diese Nutzungsbedingungen, Verstößen gegen geltende Gesetze oder Rechte
        Dritter, Fahrlässigkeit oder vorsätzlichem Fehlverhalten sowie Ansprüchen von Verbrauchern oder Dritten im
        Zusammenhang mit Ratschlägen, Informationen oder Inhalten des professionellen Nutzers.
      </p>

      <h2>12. HÖHERE GEWALT</h2>
      <p>
        Das Unternehmen haftet nicht für die Nichterfüllung von Verpflichtungen, wenn diese auf Ereignisse
        zurückzuführen ist, die außerhalb seiner zumutbaren Kontrolle liegen, einschließlich, aber nicht beschränkt auf:
        höhere Gewalt, Naturkatastrophen; Krieg, Terrorismus, Unruhen; Streiks oder Arbeitskräftemangel; Störungen der
        Kommunikationsnetze; Nichtverfügbarkeit von Zahlungsabwicklern; staatliche Maßnahmen oder gesetzliche
        Beschränkungen. Tritt ein Ereignis höherer Gewalt ein, wird das Unternehmen die betroffenen professionellen
        Nutzer innerhalb von 15 Tagen benachrichtigen und eine Schätzung der voraussichtlichen Dauer vorlegen.
      </p>

      <h2>13. KÜNDIGUNG UND SPERRUNG</h2>
      <h3>13.1 Kündigung durch das Unternehmen</h3>
      <p>
        Das Unternehmen kann den Zugang eines professionellen Nutzers zur Plattform ohne vorherige Ankündigung
        sofort aussetzen oder beenden, wenn der professionelle Nutzer gegen diese Nutzungsbedingungen verstößt;
        illegale, betrügerische oder schädliche Aktivitäten ausübt; vier (4) oder mehr Termine ohne triftigen Grund
        absagt; das Unternehmen eine gerichtliche Anordnung oder behördliche Mitteilung erhält; oder die fortgesetzte
        Erbringung von Dienstleistungen das Unternehmen einem rechtlichen oder Reputationsrisiko aussetzen würde.
        Nach Ergreifen solcher Maßnahmen erfolgt eine schriftliche Benachrichtigung.
      </p>
      <h3>13.2 Kündigung durch professionelle Nutzer</h3>
      <p>Professionelle Nutzer können diese Vereinbarung jederzeit kündigen, indem sie:</p>
      <ul>
        <li>ihr Konto über die Einstellungen der Plattform schließen; oder</li>
        <li>eine schriftliche Mitteilung an das Unternehmen senden.</li>
      </ul>
      <p>
        Nach der Kündigung wird das Unternehmen personenbezogene Daten gemäß der{' '}
        <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung (Anhang 1)</ExternalLink> und
        den geltenden Rechtsvorschriften löschen oder zurückgeben.
      </p>
      <h3>13.3 Folgen der Kündigung</h3>
      <p>Bei Beendigung:</p>
      <ul>
        <li>Der professionelle Nutzer hat keinen Zugriff mehr auf die Plattform</li>
        <li>Alle ausstehenden Zahlungen werden innerhalb einer angemessenen Frist beglichen</li>
        <li>
          Die Daten werden gemäß der <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> und der{' '}
          <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung</ExternalLink> behandelt
        </li>
        <li>
          Alle Bestimmungen, die über die Beendigung hinaus gelten sollen (einschließlich Vertraulichkeit, Freistellung
          und Haftung), bleiben weiterhin in Kraft
        </li>
      </ul>

      <h2>14. ÄNDERUNG DER BEDINGUNGEN</h2>
      <p>
        Das Unternehmen kann diese Nutzungsbedingungen, die Datenschutzerklärung und damit verbundene Richtlinien
        jederzeit aus verschiedenen rechtlichen Gründen ändern. Sollte eine Änderung den Zugang eines professionellen
        Nutzers zur Plattform oder dessen Nutzung wesentlich und nachteilig beeinträchtigen, wird das Unternehmen den
        professionellen Nutzer im Voraus darüber informieren. Der professionelle Nutzer hat dann das Recht, den Vertrag
        innerhalb von 30 Tagen nach Inkrafttreten der Änderung zu kündigen. Die fortgesetzte Nutzung der Plattform
        nach Inkrafttreten der Änderungen gilt als Zustimmung zu den geänderten Bedingungen. Professionelle Nutzer
        können zum Zeitpunkt der Registrierung eine Kopie dieser Bedingungen speichern oder aufbewahren.
      </p>

      <h2>15. ÜBERTRAGUNG VON RECHTEN</h2>
      <ul>
        <li>
          Professionelle Nutzer dürfen Rechte oder Pflichten aus dieser Vereinbarung nicht ohne die vorherige
          schriftliche Zustimmung des Unternehmens abtreten.
        </li>
        <li>
          Das Unternehmen kann seine Rechte und Pflichten aus dieser Vereinbarung nach eigenem Ermessen an Dritte
          abtreten (z. B. im Zusammenhang mit einer Fusion, einer Übernahme oder einem Unternehmensverkauf).
        </li>
      </ul>

      <h2>16. RECHT UND GERICHTSSTAND</h2>
      <h3>16.1 Anwendbares Recht</h3>
      <p>
        Diese Vereinbarung unterliegt griechischem Recht, auch wenn der Zugriff auf die Plattform von außerhalb
        Griechenlands erfolgt.
      </p>
      <h3>16.2 Streitbeilegung</h3>
      <p>
        Jede Streitigkeit, die sich aus dieser Vereinbarung ergibt oder damit in Zusammenhang steht, wird zunächst einer
        Mediation gemäß der Mediationsverordnung des griechischen Justizministeriums unterzogen. Kann die Streitigkeit
        nicht durch Mediation beigelegt werden, wird sie ausschließlich durch ein Schiedsverfahren gemäß der
        Schiedsordnung oder durch die Gerichte in Athen entschieden, die ausschließlich zuständig sind.
      </p>
      <h3>16.3 Salvatorische Klausel</h3>
      <p>
        Sollte eine Bestimmung dieser Vereinbarung von einem Gericht für ungültig oder nicht durchsetzbar erklärt
        werden, bleiben die übrigen Bestimmungen davon unberührt und weiterhin in vollem Umfang gültig.
      </p>

      <h2>17. GESAMTE VEREINBARUNG</h2>
      <p>
        Diese Nutzungsbedingungen bilden zusammen mit der{' '}
        <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> und der{' '}
        <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung (Anhang 1)</ExternalLink> die
        gesamte Vereinbarung zwischen dem professionellen Nutzer und dem Unternehmen und ersetzen alle früheren
        Vereinbarungen. Andere Bedingungen sind nur dann verbindlich, wenn sie vom Unternehmen schriftlich bestätigt
        wurden.
      </p>

      <h2>18. KONTAKTINFORMATIONEN</h2>
      <p>Bei Fragen oder Anliegen bezüglich dieser Nutzungsbedingungen wenden Sie sich bitte an:</p>
      <p>
        Unternehmen: VIVIANLAB LTD
        <br />
        Adresse: 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1
        <br />
        E-Mail: info@vivianlab.com
        <br />
        VAT: BG207933919
      </p>

      <h2>19. WICHTIGER HINWEIS: RESPEKT UND WERTSCHÄTZUNG</h2>
      <p>
        Die Plattform basiert auf den Werten Respekt und Wertschätzung. Alle professionellen Nutzer müssen diese Werte
        bei allen Interaktionen beachten.
      </p>
      <p>Nulltoleranz gegenüber:</p>
      <ul>
        <li>Beleidigender, provokativer oder bedrohlicher Sprache</li>
        <li>Diskriminierung aufgrund von Geschlecht, Geschlechtsidentität, Nationalität, Religion, Behinderung, sexueller Orientierung oder Alter</li>
        <li>Belästigung jeglicher Art</li>
      </ul>
      <p>Verstöße können zur Deaktivierung des Kontos und/oder zu rechtlichen Schritten führen.</p>

      <p>
        <strong>DIESE NUTZUNGSBEDINGUNGEN FÜR PROFESSIONELLE NUTZER WURDEN ZULETZT AM 12.05.2025 GEÄNDERT</strong>
      </p>
      <p>
        Indem Sie auf „Ich akzeptiere“ klicken oder die Plattform nutzen, bestätigen Sie, dass Sie diese
        Nutzungsbedingungen, die <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> und die{' '}
        <ExternalLink href="/de/data-processing-addendum">Datenverarbeitungsvereinbarung (Anhang 1)</ExternalLink>{' '}
        gelesen und verstanden haben und sich damit einverstanden erklären, an diese gebunden zu sein.
      </p>
    </div>
  );
}

export default ProfessionalTosGerman;
